<template>
  <div class="toolStatistics">
    <el-container  style="flex-direction: column;">
      <!-- <MachMonitor></MachMonitor> -->
      <NJNav></NJNav>
      <div class="charts-box">
        <div class="tab-box">
          <!-- <span class="title_left">*全国联网农机在江苏省的农机预警</span> -->
          <div class="times">
            <p>农机购置补贴机具预警统计</p>
            <p>统计时间：{{ getFirstDayOfYear(new Date()) }}至{{ getNowFormatDates() }}</p>
          </div>
        </div>
        <div class="charts-box-top">
          <div class="nums">
            <div class="item-nums">
              <p>预警机具累计：<span>{{ warnTatol }}</span>台</p>
            </div>
            <div class="item-nums">
              <p>未上报数据：<span>{{ unSendUpTotal }}</span>台</p>
            </div>
            <div class="item-nums">
              <p>作业面积未达标：<span>{{ areaUnqualifiedTotal }}</span>台</p>
            </div>
          </div>
        </div>
        <div class="select-block">
          <div id="ToolChart"></div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import "echarts/map/js/china.js";
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
// import MachMonitor from "./MachMonitor.vue";
import NJNav from '../Index/view/NJNav'

export default {
  name: "WarningEquipment",
  components: { NJNav },
  data() {
    return {
      Citychars: "",
      warningList: [],
      warnTatol: "",
      unSendUpTotal: "",
      areaUnqualifiedTotal: "",
      cityName:
        this.$store.state.areaName === "全国"
          ? this.$store.state.areaName + "各省"
          : this.$store.state.areaName
    };
  },
  mounted() {
    this.init();
    this.getWarning();
  },
  methods: {
    init() {
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.Citychars.resize();
        });
      }, 30);
    },
    getWarning() {
      var url = Http.test + "/screenBuyNj/statisticWarnMachine";
      var parmse = {};
      Api.doPost(url, parmse, false, res => {
        this.warningList = res.result.data;
        this.warnTatol = res.result.warnTatol;
        this.unSendUpTotal = res.result.unSendUpTotal;
        this.areaUnqualifiedTotal = res.result.areaUnqualifiedTotal;
        this.getdata(); // 首次加载无数据图
      });
    },
    getdata() {
      this.Citychars = this.$echarts.init(document.getElementById("ToolChart"));
      var areaUnqualifiedList = [];
      var unSendUpList = [];
      var proList = [];
      this.warningList.forEach(item => {
        areaUnqualifiedList.push(item.areaUnqualifiedNum);
        unSendUpList.push(item.unSendUpNum);
        proList.push(item.name);
      });

      this.Citychars.setOption({
        // tooltip: {
        //   trigger: "axis",
        //   axisPointer: {
        //     type: "cross",
        //     label: {
        //       backgroundColor: "#0B1640"
        //     }
        //   }
        // },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = '<div class="tooltipBox"><span">'+params[0].name+'</span>';
            for(var i = 0, l = params.length; i < l; i++) {
              // let unit = params[i].seriesName == '作业面积未达标' ? '亩' : '台'
              relVal += '<br/> <span>' + params[i].marker+ params[i].seriesName + ' : ' + params[i].value +'台</span>'
            }
            relVal +='</div>'
            return relVal
          }
        },
        legend: {
          data: ["未上报数据", "作业面积未达标"],
          top: 0, // 距离容器上边界40像素
          textStyle: {
            color: "#ffffff",
            fontSize: 14
          },
        },
        grid: {
          top: "7%", // 距离容器上边界40像素
          bottom: "5%", // 距离容器下边界30像素
          left: 90,
          right: 100
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              color: "#a0a0a0"
            },
            axisLine: {
              lineStyle: {
                color: "#dddddd"
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: proList
            // data: [
            //   "山东省",
            //   "湖南省",
            //   "上海市",
            //   "北京市",
            //   "天津市",
            //   "福建省",
            //   "湖北省",
            //   "河北省",
            //   "河南省"
            // ]
          }
        ],
        yAxis: [
          {
            type: "value",
            name: '机具数量（台）',
            nameTextStyle: {
              color: "#a0a0a0"
            },
            axisLabel: {
              show: true,
              color: "#a0a0a0"
              //   formatter: '{value} 台'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#dddddd"
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                width: 0.2,
                type: "dashed",
                color: "#e9e9e9"
              }
            }
          }
        ],
        series: [
          {
            name: "未上报数据",
            type: "bar",
            barWidth: 30,
            color: "#0966d9",
            stack: "name",
            data: unSendUpList
            //  data: [123, 456, 231, 321, 213, 421, 623, 95, 100]
          },
          {
            name: "作业面积未达标",
            type: "bar",
            barWidth: 30,
            stack: "name",
            color: "#ff961b",
            data: areaUnqualifiedList
            // data: [200, 332, 456, 458, 897, 123, 456, 458, 748]
          }
        ]
      });
    },
   timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear(); // 年
      // this.yearValue = y
      var m = date.getMonth() + 1; // 月
      var d = date.getDate(); // 日
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 1 && d <= 9) {
        d = "0" + d;
      }
      // return y + "-" + m + "-" + d;
       return y + '年' + m + '月' + d + '日'
    },
    // 获取本年第一个月
    getFirstDayOfYear(date) {
      date.setDate(1);
      date.setMonth(0);
      return this.timeFormat(date);
    },
    // 获取当前日期
    getNowFormatDates() {
      var date = new Date();
      var seperator1 = "-";
      // var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // var currentdate = year + seperator1 + month + seperator1 + strDate;
       var currentdate = month + '月' + strDate + '日'
      return currentdate;
    }
  }
};
</script>
<style scoped>
p {
  color: #fff;
}
.toolStatistics {
  width: 100%;
  height: 72vh;
}
.charts-box {
  width: 98%;
  height: 83vh;
  /* height: 100%; */
  background-image: url("/static/img/zuoyejindu-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-left: 1%;
  margin-top: 1vh;
}
/* @media screen and (max-width: 1540px) {
  .charts-box {
    height: 80vh;
  }
} */
.charts-box-top {
  padding: 0vh 20px 2vh 20px;
  display: flex;
  justify-content: flex-start;
}
.select-block {
  width: 100%;
  height: 67vh;
  margin: 0 auto;
}
#ToolChart {
  width: 100%;
  height: 67vh;
}
.tab-box {
  width: 98%;
  /*margin-left: 1%;*/
 margin: 0 auto;
  /* display: -webkit-box;
  display: -ms-flexbox;
  display: flex; */
}
.tablist_item {
  width: 30%;
  display: flex;
}

.nums {
  width: 45vw;
  display: flex;
}
.item-nums {
  width: 30%;
  text-align: center;
  margin-right: 0;
}
.item-nums p{
  font-size: 0.9vw;
  color: #439BFF;
}
.item-nums p span{
  font-size: 1.2vw;
  color: #439BFF;
}
</style>



// WEBPACK FOOTER //
// src/components/TableList/WarningEquipment.vue